module.exports = __webpack_public_path__ + "img/sdg_pt-pt_(5).f8627dbf.png";